import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

import { dictionaryTypeList, printTypeList } from './DictionaryTypes';

export const dictionarySchema = z.object({
  title: z.string().min(3),
  publisher: identitySchema,
  printType: z.enum(printTypeList),
  type: z.enum(dictionaryTypeList),
  isbnPrint: z.string(),
  eisbn: z.string(),
  link: z.string(),
  authors: z.array(authorSchema).min(1),
  publicationYear: z.number(),
  noOfPages: z.number(),
});

export const defaultDictionaryValues: DefaultValues<DictionarySchema> = {
  title: '',
  isbnPrint: '',
  eisbn: '',
  link: '',
  authors: [],
  publicationYear: new Date().getFullYear(),
};

export type DictionarySchema = z.infer<typeof dictionarySchema>;
